module.exports = __webpack_public_path__ + "static/media/main-1.58862edf.png";